import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getAllFilesService(docId, page, rowsPerPage, next, options, clientKey, userKey) {
  validateUserKey(userKey);
  try {
    let from = new Date();
    from.setDate(from.getDate() - 10);
    let to = new Date();
    const { data } = await apiClient.post("api/files", {
      docId,
      pageSize: rowsPerPage,
      pageNo: page,
      next,
      clientKey,
      userKey,
      options: options
        ? {
            timeframe: {
              start: options.timeframe.start,
              end: options.timeframe.end,
            },
          }
        : {
            timeframe: {
              start: from,
              end: to,
            },
          },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
